import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useNotificationStore } from "stores/notifications";
import PropTypes from "prop-types";
import { useMutation } from "react-query";

export const reportMalpractice = ({ data }) => {
  return axios.post(`/malpractice-reports`, data);
};

export const useReportMalpractice = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onMutate: async (newPost) => {
      await queryClient.cancelQueries("malpracticeReports");

      const previousPosts = queryClient.getQueryData("malpracticeReports");

      queryClient.setQueryData("malpracticeReports", [
        ...(previousPosts || []),
        newPost.data,
      ]);

      return { previousPosts };
    },
    onError: (_, __, context) => {
      if (context?.previousPosts) {
        queryClient.setQueryData("malpracticeReports", context.previousPosts);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries("malpracticeReports");
      addNotification({
        type: "success",
        title:
          "Thank you for reporting this malpractice. We will be in touch in 3 working days.",
      });
    },
    ...config,
    mutationFn: reportMalpractice,
  });
};
